import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { CertificationManage as LocalCertificationManage } from '../../components/CertificationManage'

export const CertificationManage = connect(
  LocalCertificationManage,
  mapReadPretty(LocalCertificationManage, {
    disabled: true
  })
)
